
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class NoticeArea extends Vue {
  @Prop({ required: true }) readonly message!: string;
}
